import { DefaultCarousel } from "./constants";
import type { CarouselOptions, CoverImageElement, VariantKey } from "./types";

export function getVariantStyledUrl(
  image: CoverImageElement | null | undefined,
  variant: VariantKey,
): string | undefined {
  switch (variant) {
    case "landscape250x99":
      return image?.landscape250x99?.url ?? undefined;
    case "size80x80":
      return image?.size80x80?.url ?? undefined;
    case "size118x118":
      return image?.size118x118?.url ?? undefined;
    case "size320x180":
      return image?.size320x180?.url ?? undefined;
    case "size320x240":
      return image?.size320x240?.url ?? undefined;
    case "size500x500":
      return image?.size500x500?.url ?? undefined;
    case "size540x360":
      return image?.size540x360?.url ?? undefined;
    case "size640x360":
      return image?.size640x360?.url ?? undefined;
    case "size660w":
      return image?.size660w?.url ?? undefined;
    case "size768x768":
      return image?.size768x768?.url ?? undefined;
    case "size800x1200":
      return image?.size800x1200?.url ?? undefined;
    case "size1200x800":
      return image?.size1200x800?.url ?? undefined;
    case "size1200x1200":
      return image?.size1200x1200?.url ?? undefined;
    case "size1280x720":
      return image?.size1280x720?.url ?? undefined;
    case "size1676x943":
      return image?.size1676x943?.url ?? undefined;
  }
}

export function resolveCarouselOptions(withCarousel: CarouselOptions | undefined) {
  if (!withCarousel) return null;
  return withCarousel === true ? DefaultCarousel : withCarousel;
}
